import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShoppingBag, ChevronRight } from "lucide-react";
import { useCart } from "../contexts/CartContext";

/**
 * Persistent cart bar (Uber-Eats style).
 * Floats above the bottom navigation when the cart has items.
 * Hidden on /checkout to avoid duplication.
 */
export const CartBar = ({ bottomOffset = 72 }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { items, count, subtotal } = useCart();

    if (count === 0) return null;
    if (location.pathname === "/checkout") return null;
    if (location.pathname.startsWith("/order/")) return null;

    return (
        <div
            data-testid="cart-bar"
            className="fixed left-0 right-0 z-[455] px-3"
            style={{ bottom: `calc(${bottomOffset}px + env(safe-area-inset-bottom))` }}
        >
            <button
                onClick={() => navigate("/checkout")}
                className="gold-cta w-full h-14 rounded-2xl flex items-center justify-between px-4 shadow-[0_10px_40px_rgba(244,179,57,0.4)] active:scale-[0.99] transition"
            >
                <span className="flex items-center gap-3">
                    <span className="relative h-9 w-9 grid place-items-center rounded-full bg-[#0B0B0F]/15">
                        <ShoppingBag size={18} strokeWidth={2.5} />
                        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 grid place-items-center rounded-full bg-[#0B0B0F] text-[var(--gold-light)] text-[10px] font-mono font-bold">
                            {count}
                        </span>
                    </span>
                    <span className="flex flex-col items-start leading-tight">
                        <span className="text-[10px] font-mono uppercase tracking-widest opacity-70">// καλάθι</span>
                        <span className="text-sm font-heading font-black uppercase tracking-wide" style={{ fontFamily: '"Cormorant Garamond", serif' }}>
                            {items[0]?.store_name || "Δες την παραγγελία σου"}
                        </span>
                    </span>
                </span>
                <span className="flex items-center gap-2">
                    <span className="font-mono text-base font-bold">€{subtotal.toFixed(2)}</span>
                    <ChevronRight size={20} strokeWidth={3} />
                </span>
            </button>
        </div>
    );
};
